// extracted by mini-css-extract-plugin
export default {"paginationMain":"Pagination_paginationMain__quX07"};